import { Messages } from '../../codegen/Localize';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';

/**
 * Adds a filter to allow pug files to use On-Prem vs Online specific messages
 * without polluting a controller's scope.
 *
 * tokens need to have `_online` and `_server` at the end.
 * 
 * This method is deprecated, in the react components follow the example below if you want a string based on server environment
 *
     function useSelectDescriptionByServerEnvironment() {
      return useSelector<boolean>(SessionServerSelectors.isOnlineEnvironment)
        ? Messages.settings_siteStartPage_description_online()
        : Messages.settings_siteStartPage_description_server();
      }
 */
export const DeprecatedSelectByServerEnvironment =  (token: string) => {
  const server = getSessionManagementServiceInstance();
  const environmentSpecificToken = server.isOnlineEnvironment() ? `${token}_online` : `${token}_server`;
  // This loses typesafety, but this is temporary until the 4 usages in pug settings are migrated.
  return (Messages as any)[environmentSpecificToken]();
};